const dragDropFile = {
  upload: {
    drag: 'Legen Sie Ihre Datei hier ab oder',
    browse: 'Durchsuchen Sie Ihre Dateien.',
  },

  uploaded: {
    success: 'Datei {{name}} wurde erfolgreich hochgeladen',
    chooseAnotherFile: 'Wählen Sie eine andere Datei.',
  },
};

export default dragDropFile;
